export function formatEmployeeExperience(employee) {
  const details = [];
  if (employee?.experience_level) details.push(employee.experience_level);
  if (employee?.years_experience !== null && employee?.years_experience !== undefined && employee.years_experience !== '') {
    const years = Number(employee.years_experience);
    details.push(`${years} ${years === 1 ? 'ano' : 'anos'} de atuação`);
  }
  return details.join(' · ');
}
